import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import {
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { transformBrandName } from '../utils';

const ProductReviewsHeader = ({ itemId }) => {
  const { data, error, loading } = useDataModel('product',
    {
      variables: {
        itemId
      }
    }
  );

  if ((loading && !(data || data?.product?.identifiers)) || error) {
    return null;
  }

  const { brandName = '', productLabel = '' } = data?.product?.identifiers || {};

  const transformedBrandName = transformBrandName(brandName);

  return (
    <Typography component="h1" variant="h3" weight="bold">
      {`Customer Reviews for ${transformedBrandName ? transformedBrandName + ' ' : ''}${productLabel}`}
    </Typography>
  );
};

ProductReviewsHeader.dataModel = {
  product: params({
    itemId: stringType().isRequired()
  }).shape({
    itemId: stringType(),
    identifiers: shapeType({
      brandName: stringType(),
      productLabel: stringType(),
    }),
  })
};

ProductReviewsHeader.propTypes = {
  itemId: PropTypes.string.isRequired
};

ProductReviewsHeader.displayName = 'ProductReviewsHeader';

export default ProductReviewsHeader;